import React from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import Button from "components/Button";
import DatePickerField from "components/DatePickerField";
import { endOfMonth } from "date-fns";

const ResyncSchema = Yup.object().shape({
  dateFrom: Yup.date().required("Date From is required").nullable(),
});

const ShelterBuddyResyncForm = ({ onSubmit, isLoading, isProcessing }) => {
  return (
    <Formik
      initialValues={{ dateFrom: null }}
      validationSchema={ResyncSchema}
      onSubmit={onSubmit}
    >
      {({ isValid, dirty }) => (
        <Form className="flex items-end gap-6 w-full">
          <div className="flex-1">
            <DatePickerField
              label="Date From (Month/Year)"
              name="dateFrom"
              dateFormat="MMMM yyyy"
              showMonthYearPicker
              placeholderText="Select month and year"
              maxDate={endOfMonth(new Date())}
              disabled={isProcessing}
              required
              containerClassName="w-full"
              className="w-full"
            />
          </div>
          <div className="mb-1 flex-shrink-0">
            <Button
              type="submit"
              disabled={!isValid || !dirty || isProcessing}
              isLoading={isLoading}
              loadingText="Starting..."
            >
              Start Resync
            </Button>
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default ShelterBuddyResyncForm;
